import { useCallback, useState } from "react";
import { IoMdDownload } from "react-icons/io";
import ReactTooltip from "react-tooltip";
import { AggregatedViews } from "../../hooks/useObjectViews";
import SpotLoader from "../misc/SpotLoader";

export type DownloadButtonProps = {
  onDownload: () => Promise<any>;
  views?: AggregatedViews;
  className?: string;
  viewsInPack?: AggregatedViews;
};

export const DownloadButton = ({
  onDownload,
  views = null,
  className = "",
  viewsInPack,
  ...rest
}: DownloadButtonProps) => {
  const [loading, setLoading] = useState(false);
  const onClick = useCallback(async () => {
    setLoading(true);
    await onDownload();
    setLoading(false);
  }, [onDownload]);

  const _views = viewsInPack || views;
  const viewersNicknames = _views?.viewers?.filter((v) => !!v.nickname).map((v) => `@${v.nickname}`);
  const anonNumber = _views?.viewers?.filter((v) => !v.nickname).length;

  return loading ? (
    <SpotLoader style={{ width: 18 }} className="ml-4" {...rest} />
  ) : (
    <div
      className={className + " flex items-center"}
      data-for="download-tooltip"
      data-tip={
        `Downloaded by ${_views?.viewers?.length} ` +
        (viewersNicknames?.length
          ? `\n(${viewersNicknames.join(", ")}${anonNumber > 0 ? ` + ${anonNumber} anonymous` : ""})`
          : "")
      }
    >
      {
        <div className={`sysfont w-3 text-xs flex items-center justify-center  h-3 p-1 `}>
          {_views?.viewers?.length > 0 ? _views?.viewers?.length : " "}
        </div>
      }
      <IoMdDownload
        style={{ width: 18 }}
        size={18}
        onClick={onClick}
        className={" shrink-0 w-5 h-5 group-hover:opacity-100 "}
        {...rest}
      />
      {_views?.viewers?.length > 0 && (
        <ReactTooltip
          id="download-tooltip"
          className="whitespace-nowrap z-50"
          delayShow={400}
          place="bottom"
          effect="solid"
        />
      )}
    </div>
  );
};
